import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingProductos from "./assets/components/LandingProductos";
import { Box, CircularProgress, Typography } from "@mui/material";
import ProtectedRoute from "./assets/Routes/ProtectedRoutes";
import { Analytics } from "@vercel/analytics/react";
import { CartProvider } from "./assets/Context/CartContext";

const LandingPage = React.lazy(() => import("./assets/pages/landing"));
const NOTFOUND = React.lazy(() => import("./assets/pages/404"));
const Contactanos = React.lazy(() => import("./assets/pages/Contactanos"));
const Productos = React.lazy(() => import("./assets/pages/Productos"));
const Login = React.lazy(() => import("./assets/pages/Login"));
const Admin = React.lazy(() => import("./assets/pages/Admin"));
const OvumShop = React.lazy(() => import("./assets/pages/OvumShop"));
const Success = React.lazy(() => import("./assets/pages/Success"));
const Cancel = React.lazy(() => import("./assets/pages/Cancel"));
const Catalogo = React.lazy(() => import("./assets/pages/Catalogo"));
const ResetPassword = React.lazy(() => import("./assets/pages/ResetPassword"));

const App = () => {
  return (
    <CartProvider>
      <Router>
      <Suspense
        fallback={
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              backgroundColor: "#f5f5f5",
            }}
          >
            <CircularProgress
              size={60}
              thickness={5}
              sx={{ color: "#479f19" }}
            />
            <Typography
              variant="h6"
              sx={{
                marginTop: "20px",
                color: "#333",
                fontWeight: "bold",
              }}
            >
              Cargando, por favor espera...
            </Typography>
          </Box>
        }
      >
        <Routes>
          {/* Página principal */}
          <Route path="/" element={<LandingPage />} />

          {/* Rutas adicionales */}
          <Route path="/Inicio" element={<LandingPage />} />
          <Route path="/Contactanos" element={<Contactanos />} />
          <Route path="/Productos" element={<Productos />} />
          <Route path="/login" element={<Login />} />
          <Route path="/OvumShop" element={<OvumShop />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/Catalogo" element={<Catalogo />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route
            path="/Admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />

          <Route path="/productos-landing" element={<LandingProductos />} />

          <Route path="*" element={<NOTFOUND />} />
        </Routes>
      </Suspense>
      <Analytics />
      </Router>
    </CartProvider>
  );
};

export default App;
